import React from "react";
import { Box, Drawer, IconButton } from "@mui/material";
import ReactBarcode from "react-jsbarcode";
import { useEffect, useState, useRef } from "react";
import html2canvas from "html2canvas";
import { rem } from "assets/js/common";

// 점포코드별 바코드 하단 문구 (목록에 없는 점포는 미노출)
const STORE_REGION = {
  2701: "부산", // 동래점
  2708: "부산", // 기장점
  2774: "부산", // 문현점
  2778: "부산", // 덕천점
  2705: "울산", // 울산점
  2702: "울산", // 언양점
  2709: "김해", // 김해점
  2775: "김해", // 외동점
  2776: "양산", // 덕계점
  2756: "방이", // 방이점
};

export default function ReceiptDrawer(props) {
  const region = STORE_REGION[props.storeCode];
  const textRef = useRef(null);
  const imgRef = useRef(null);
  const preRef = useRef(null);

  useEffect(() => {
    if (textRef.current && props.receiptDetail)
      // 폰트 로드 전에 캡처하면 기본 monospace로 찍혀 정렬이 틀어짐
      // (구글폰트 한글은 글자별 서브셋 분할이라 영수증 텍스트를 넘겨 필요한 서브셋을 모두 로드)
      document.fonts
        .load("12px 'Nanum Gothic Coding'", props.receiptDetail)
        .then(() => {
          // 40칸보다 긴 줄이 있으면 줄바꿈되며 정렬이 깨지므로, 가장 긴 줄이 폭에 맞도록 글자 크기 축소
          const pre = preRef.current;
          const range = document.createRange();
          range.selectNodeContents(pre);
          const textWidth = range.getBoundingClientRect().width;
          if (textWidth > pre.clientWidth) {
            const fontSize = parseFloat(getComputedStyle(pre).fontSize);
            pre.style.fontSize = `${(fontSize * pre.clientWidth) / textWidth}px`;
          }
          return html2canvas(textRef.current, {
            useCORS: true,
          });
        })
        .then(function (canvas) {
          imgRef.current.src = canvas.toDataURL("image/png");
          textRef.current.style.display = "none";
        });
  }, [textRef.current, props.receiptDetaill, props.drawerFull]);

  return (
    <>
      <Drawer
        anchor="bottom"
        open={props.drawerFull}
        onClose={() => props.handleCancel()}
        className="drawer-common-bottom size-full title-center"
      >
        <div className="drawer-head">
          <img
            src={`${process.env.PUBLIC_URL}/images/icon/logo_red.svg`}
            alt="메가마트"
            style={{
              position: "absolute",
              left: rem(25),
              // 닫기 버튼(top 22 + 높이 24)과 세로 중앙 맞춤
              top: rem(29),
              transform: "translateY(-50%)",
              width: rem(117),
            }}
          />
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={() => props.handleCancel()}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box
            p={4}
            style={{
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <img
                ref={imgRef}
                style={{
                  width: "100%",
                }}
              />
            </div>
          </Box>
        </div>
      </Drawer>
      {props.drawerFull && (
        <div
          ref={textRef}
          style={{
            position: "absolute",
            width: "calc(100vw - 40px)",
            top: "100vh",
            zIndex: -1,
          }}
        >
          {props.barcodeNum && (
            <div
              className="receipt-barcode"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: `${rem(16)} 0 ${rem(32)} 0`,
              }}
            >
              <ReactBarcode
                value={props.barcodeNum}
                options={{
                  format: "code128",
                  font: "14px NanumSquareRound",
                  height: 60,
                  // textMargin: 15,
                  // displayValue: false,
                }}
                renderer="svg"
              />
              {region && (
                <p
                  style={{
                    fontFamily: "NanumSquareRound",
                    fontSize: rem(14),
                    fontWeight: 700,
                    textAlign: "center",
                    marginTop: rem(8),
                  }}
                >
                  "식품 전문 매장 {region} No1. 메가마트"
                </p>
              )}
            </div>
          )}
          <pre
            ref={preRef}
            style={{
              // 한글 1자 = 영문 2칸 고정폭 폰트 (POS 영수증 칸 맞춤)
              fontFamily: "'Nanum Gothic Coding', monospace",
              // 한 줄 40칸(=20em)이 캡처 폭을 꽉 채우도록 글자 크기를 화면 폭에 맞춤
              fontSize: "calc((100vw - 40px) / 20)",
              textAlign: "center",
              letterSpacing: 0,
              lineHeight: 1.667,
              wordSpacing: "normal",
              whiteSpace: "pre",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* POS 프린터 제어코드(ESC|2C, ESC|1C 등) 제거 */}
            {/* 바코드는 상단에 별도 노출하므로 POS 바코드 인쇄 위치 문구 제거 */}
            {props.receiptDetail &&
              props.receiptDetail
                .replace(/\u001b\|\d*[A-Za-z]/g, "")
                .replace(/거래바코드출력\r?\n?/g, "")}
          </pre>
        </div>
      )}
    </>
  );
}
